import { faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex } from '@modusign/design-system';
import { LabelWithBookmarkResponse } from '@modusign/openapi-client-category/generated/model';
import { ReactNode, useState } from 'react';

import LabelListItemMenuPopover from '@app/features/label/components/LabelPopovers/components/LabelListItem/LabelListItemMenuPopover';
import useResponsiveValue from '@app/hooks/useResponsiveValue';

interface LabelListItemProps {
  active?: boolean;
  label: LabelWithBookmarkResponse;
  children: ReactNode;
}

function LabelListItem({ active, children, label }: LabelListItemProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const isMobileWidth = useResponsiveValue([true, false, false]);

  return (
    <Flex
      alignItems="center"
      bg={active || isPopoverOpen ? 'tableBackgroundNeutralDark' : null}
      justifyContent="space-between"
      px={4}
      sx={{ '&:hover': { bg: 'tableBackgroundNeutralDark' } }}
    >
      {children}
      {!isMobileWidth && (
        <LabelListItemMenuPopover
          hasBookmarked={!!label.bookmark}
          isOpen={isPopoverOpen}
          labelId={label.id}
          onOpenChange={setIsPopoverOpen}
        >
          <Box as="button" flex="none" p={3}>
            <Box as={FontAwesomeIcon} color="textNeutralLight" icon={faEllipsis} />
          </Box>
        </LabelListItemMenuPopover>
      )}
    </Flex>
  );
}

export default LabelListItem;
